module.exports = __webpack_public_path__ + "img/20240201110422925tos.e6f9bbe1.jpg";